import { FormLabel } from "@/components/ui/form";
import { cn } from "@/lib/utils";

export const InputFieldLabel = ({
  label,
  description,
  isRequired = false
}: {
  label?: string;
  description?: string;
  isRequired?: boolean;
}) => {

  return (
    <>
      {label && (
        <FormLabel
          className={cn('flex justify-start font-medium text-primary !text-sm', `${!description ? 'mb-2' : ''}`)}
          isRequired={isRequired}
        >
          {label}
        </FormLabel>
      )}
      {description && <p className="text-secondary text-sm font-normal -mt-1 mb-1 text-left">{description}</p>}
    </>
  )
}
